import { isValidURL } from '~/utils/url';

export default ({ redirect, query }) => {
  const redirectUrl = query.redirect_url;

  if (redirectUrl !== undefined && !isValidURL(redirectUrl)) {
    redirect({ query: { ...query, redirect_url: undefined } });
  }
};
